import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaTriangleExclamation, FaCheck } from "react-icons/fa6";

import { ToastProps, ToastTypes } from "./Toast.types";
import CloseButton from "../../atoms/CloseButton/CloseButton";

import "./Toast.scss";

const Toast: React.FC<ToastProps> = ({
  message,
  type,
  show,
  dismiss,
  dismissable,
}: ToastProps) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (show) {
      timer = setTimeout(dismiss, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="mp-organisms-toast--main">
          <motion.div
            className={`content ${type}`}
            initial={{
              opacity: 0,
              y: 40,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            exit={{
              opacity: 0,
              y: 40,
            }}
          >
            <div className="message-container">
              {type === ToastTypes.warning && <FaTriangleExclamation />}
              {type === ToastTypes.success && <FaCheck />}
              <div>{message}</div>
              {dismissable && (
                <CloseButton dark={false} handleClose={dismiss} />
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;
